export default __webpack_public_path__ + "static/Create-new-campaign-507d82d90a28dcfde5fcd60962ddda03.png";